import React, { useState } from 'react';
import { Grid } from '@material-ui/core';
import { Button, Col, Form, Row, Card, Select, Modal, Layout, message } from 'antd';
import ActionButtonsBar from '../../ui/ActionButtonsBar';
import { LocalPersistence } from '../../../factories';
import { updateOtherCardTypes, deleteOtherCardTypes } from '../../../services/otherPayments';
import PageContainer from '../../CSIComponents/PageContainer';
import DetailItem from '../../CSIComponents/DetailItem';
import Loading from '../../Loading';
import styles from '@components/Attraction/index.module.css';

const { Option } = Select;

const EditOtherCardTypes = (props: any) => {
  const detailData = [
    { label: 'Card Type', value: props.rowData.cardtype, span: 6 },
    { label: 'Use For Guarantee', value: props.rowData.useforguarantee, span: 6 },
    { label: 'Use For Deposit', value: props.rowData.usefordeposit, span: 6 },
    { label: '', value: '', span: 6 },
    { label: 'Use For Payment', value: props.rowData.useforpayment, span: 6 }
  ]
  const [editFlag, setEditFlag] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const [form] = Form.useForm();
  const [disableFlag, setDisableFlag] = useState(false);


  const addSave = () => {
    form.validateFields().then(async (value) => {
      const get_session = new LocalPersistence('session')
      const session: any = await get_session.getSessionPersistence()
      const params = {
        "supplier": session.supplier,
        "propertyId": session.propertyId,
        "property": {
          "otherpayments": {
            "othercardtypes": [
              {
                ...value,
                cardid: props.rowData.cardid,
              }
            ]
          }
        }
      }
      const formData = {
        cardtype: value.cardtype,
        useforguarantee: value.useforguarantee,
        usefordeposit: value.usefordeposit,
        useforpayment: value.useforpayment
      }
      form.setFieldsValue(formData)
      setAddLoading(true)
      const res = await updateOtherCardTypes(params);
      if (res.result.success) {
        setEditFlag(false);
        props.setRowData({ ...props.rowData, ...formData })
      } else {
        message.error({
          content: res?.errors[0]?.message
        });
      }
      setAddLoading(false)

    })
  }
  const handleDelete = async () => {
    const get_session = new LocalPersistence('session')
    const session: any = await get_session.getSessionPersistence()
    const params = {
      "supplier": session.supplier,
      "propertyId": session.propertyId,
      "property": {
        "otherpayments": {
          "othercardtypes": [
            {
              "cardid": props.rowData.cardid,
            }
          ]
        }
      }
    }
    setAddLoading(true)
    const res = await deleteOtherCardTypes(params);
    if (res.result.success) {
      form.resetFields();
      props.cancelAddAndEdit(true);
    } else {
      message.error({
        content: res?.errors[0]?.message
      });
    }
    setAddLoading(false)
  }

  const ModalHead = () => {
    return (
      <div className={styles.modalHead}>Confirm</div>
    )
  }

  const showModal = () => {
    Modal.confirm({
      title: <ModalHead />,
      centered: true,
      icon: '',
      content:`Are you sure you want to delete ${props.rowData?.cardtype ? props.rowData?.cardtype : ''} ?`,            
      cancelText: 'Cancel',
      okText: 'Delete',
      onOk: async() => handleOk(),
      onCancel() {
        setIsModalVisible(false)
      },
    });
  }

  const handleOk = () => {
    setIsModalVisible(false);
    handleDelete()
  };

  const validateForm = () => {
    form.validateFields().then(() => {
      setDisableFlag(false)
    }).catch(err => {
      err.errorFields.length ? setDisableFlag(true) : setDisableFlag(false)
    });
  }

  const editHandle = () => {
    setEditFlag(true);
    console.log(props.rowData);
    const initialValues = {
      cardid: props.rowData.cardid,
      name: props.rowData.name,
      cardtype: props.rowData.cardtype,
      useforguarantee: props.rowData.useforguarantee,
      usefordeposit: props.rowData.usefordeposit,
      useforpayment: props.rowData.useforpayment
    }
    form.setFieldsValue(initialValues);
  }

  if (addLoading) return <Loading type="large" />
  return editFlag ? (
    <PageContainer>
      <Card className='db-page'>
        <Grid container spacing={0} className='py-0'>
          <Grid item xs={12} className='p-0'>
            <div className='db-title-wrap'>
              <div className='db-title'>{props.rowData.cardtype}</div>
            </div>
          </Grid>
          <Grid item xs={12} className='db-content-wrap pb-0 px-0 my-0'>
            <Form
              layout='vertical'
              form={form}
              name='basic'
              onValuesChange={validateForm}>
              <Row gutter={24}>
                <Col span={6}>
                  <Form.Item label='Card Type' name='cardtype'>
                    <Select allowClear showSearch>
                      <Option value='Air Pluma'>Air Pluma</Option>
                      <Option value='Optima'>Optima</Option>
                      <Option value='Union Credit'>Union Credit</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label='Use For Guarantee' name='useforguarantee'>
                    <Select allowClear showSearch>
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item name='usefordeposit' label='Use For Deposit'>
                    <Select allowClear showSearch>
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}></Col>
                <Col span={6}>
                  <Form.Item label='Use For Payment' name='useforpayment'>
                    <Select allowClear showSearch>
                      <Option value='Yes'>Yes</Option>
                      <Option value='No'>No</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
            </Form>
          </Grid>
        </Grid>
      </Card>
      <ActionButtonsBar
        onDelete={showModal}
        onCancel={() => {
          props.cancelAddAndEdit()
          form.resetFields()
        }}
        onSave={addSave}
        disabledSave={disableFlag}
      />
    </PageContainer>
  ) : (
    <PageContainer>
      <Card className='db-page'>
        <Grid container spacing={0} className='py-0'>
          <Grid item xs={12} className='p-0'>
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <div style={{ margin: '0 10px 0 0' }}>
                <Button
                  className='db-edit-btn'
                  onClick={() => {
                    props.cancelAddAndEdit()
                    form.resetFields()
                  }}>
                  Back
                </Button>
              </div>
              <div>
                <Button
                  className='db-edit-btn'
                  onClick={() => {
                    editHandle()
                    props.isEditable()
                    props.disableTabPanes(true)
                  }}>
                  Edit
                </Button>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} className='p-0'>
            <div className='db-title-wrap'>
              <div className='db-title'>{props.rowData.cardtype}</div>
            </div>
          </Grid>
          <Grid item xs={12} className='pb-0 px-0 my-0'>
            <Row gutter={24} className='db-content-wrap'>
              {detailData.map((item, i) => {
                return item.label ? (
                  <Col span={item.span} key={i} className='col-margin'>
                    <DetailItem value={item.value} label={item.label} />
                  </Col>
                ) : (
                  <Col span={item.span} key={i}></Col>
                )
              })}
            </Row>
          </Grid>
        </Grid>
      </Card>
    </PageContainer>
  )
}
export default EditOtherCardTypes;
